/**
 * Adds the numeric average (for example "4.8") next to the Judge.me preview-badge stars.
 * Judge.me renders the badge asynchronously and may re-render it, so the number is
 * inserted idempotently and re-checked when the badge markup changes.
 */
(() => {
  if (window.__pdpReviewBadgeLoaded) return;
  window.__pdpReviewBadgeLoaded = true;

  const NUMBER_CLASS = 'pdp-review-average';

  const decorate = (root) => {
    root.querySelectorAll('.jdgm-prev-badge[data-average-rating]').forEach((badge) => {
      const reviews = parseInt(badge.getAttribute('data-number-of-reviews'), 10);
      const average = parseFloat(badge.getAttribute('data-average-rating'));
      const existing = badge.querySelector(`.${NUMBER_CLASS}`);

      if (!reviews || Number.isNaN(average)) {
        if (existing) existing.remove();
        return;
      }

      const value = average.toFixed(1);
      if (existing) {
        if (existing.textContent !== value) existing.textContent = value;
        return;
      }

      const stars = badge.querySelector('.jdgm-prev-badge__stars');
      if (!stars) return;

      const number = document.createElement('span');
      number.className = NUMBER_CLASS;
      number.textContent = value;
      stars.insertAdjacentElement('afterend', number);
    });
  };

  const init = () => {
    const containers = document.querySelectorAll('.product__info-container');
    if (!containers.length) return;

    containers.forEach((container) => {
      let scheduled = false;
      const run = () => {
        scheduled = false;
        decorate(container);
      };

      decorate(container);
      new MutationObserver(() => {
        if (scheduled) return;
        scheduled = true;
        requestAnimationFrame(run);
      }).observe(container, { childList: true, subtree: true });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
